import { useQuery } from "@tanstack/react-query";

import { apiClient } from "@/api/client";

export const SYNC_STATUS_KEY = ["dashboard", "sync-status"] as const;

/**
 * GET /v1/orders/sync-status — newest marketplace_raw_orders row's
 * fetched_at, shown as "Marketplace sync" in the page header.
 */
export function useSyncStatus() {
  return useQuery({
    queryKey: SYNC_STATUS_KEY,
    queryFn: async () => {
      const { data, error } = await apiClient.GET("/v1/orders/sync-status");
      if (error) throw error;
      return data;
    },
    refetchInterval: 60_000,
  });
}
